<template>
    <div class="introduction">
        <!-- <h1 class="title"> {{title}} </h1> -->
        <h2 class="subtitle">{{subtitle}}</h2>

        <div class="authors">
            <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
                <span>By</span>
                <a class="link" :href="author[1]" v-for="author in authors">{{ author[0] }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Introduction',
        props: ['title', 'subtitle', 'authors'],
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';

    .introduction {
        margin: 15px 0;
        width: 280px;

        @media screen and (max-width: 380px) {
            margin: 20px 0;
            width: 270px;
        }

        .authors {
            font-size: 13px;
            
            span {
                margin-right: 10px;
            }

            a.link {
                margin-right: 10px;
                white-space: nowrap;
                margin-bottom: 5px;
                cursor: pointer;
            }
        }
    }

    .link {
        color: $color-primary;
        text-decoration: none;
        padding-bottom: 1px;
        border-bottom: 1px solid $color-primary;
        transition: opacity $time-s ease-in-out;

        &:hover {
            opacity: .3;
            transition: opacity $time-s ease-in-out;
        }
    } 

</style>


